import styled from 'styled-components';

const StyledNav = styled.nav`
  margin-top: 24px;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  color: ${({ theme }) => theme.COLORS.BASE};
  overflow: hidden;
  position: relative;
  display: flex;
  height: 100%;
  width: 100%;
  ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    width: 100%;
    position: relative;
    margin-bottom: 10px;
    padding: 0 12px;

    li {
      font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
      background: ${({ theme }) => theme.COLORS.TRANSPARENT};
      cursor: pointer;
      height: 100%;
      max-height: 54px;

      &:hover {
        background: ${({ theme }) => theme.COLORS.BASE};
      }
    }

    a {
      display: flex;
      justify-content: center;
      align-items: center;
      color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
      height: 100%;
      text-transform: ${({ isOmp }) => (isOmp ? 'none' : 'uppercase')};

      &:focus {
        outline: -webkit-focus-ring-color auto 1px;

        &:not(:focus-visible) {
          outline: none;
        }
      }

      body.using-mouse &:focus {
        outline: none;
      }
    }
  }
  .searchLink-selected {
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  }
  .search-active-state {
    position: absolute;
    bottom: 0;
    border-bottom: 3px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};
  }
`;

export default StyledNav;
